import icikad       from '../pages/landing'


export default [
    {
        path: '/icikad',
        name: 'icikad',
        component: icikad,
    }
]
